
















import { Component, Vue } from 'vue-property-decorator';
import AutoComplete from "v-autocomplete";
import SearchTemplate from "../templates/SearchTemplate.vue";

Vue.use(AutoComplete);

@Component({
    props: {
        placeholder: String,
        searchEndpoint: Function
    }
})
export default class Search extends Vue {

    declare searchEndpoint;
    declare placeholder;

    SearchTemplate = SearchTemplate;

    model: { name: string, id: number } = null;
    items = [];

    reset: boolean = false;
    initialLoad: boolean = true;

    onChange(e) {
        this.$emit('input', e);
    }

    onInput() {

        if(this.initialLoad) {
            this.initialLoad = false;
            return;
        }

        if(this.model) {
            this.$emit('itemSelected', this.model);
            this.reset = false;
        } else if(!this.reset) {
            this.reset = true;
            this.$emit('itemSelected', null);
        }
    }

    async updateSearchResults(text: string) {
        if(text.length) {
            this.items = await this.searchEndpoint(text);
        }
    }

    getSearchLabel(item) {
        return item ? item.name : "";
    }
}
